import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@womcorp/wom-miwom-ui-kit/dist/components/Input/Formik/index';
import {
  FieldsetStyled as Fieldset,
  FieldStyled as Field,
  FieldTitleStyled as FieldTitle,
} from '../../styles/FormsStyled';
import AffectedNumberField from '../../helpers/AffectedNumberField';
import { GoogleTagManager } from '../../../../../helpers';

const StepOne = ({ setError }) => {
  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/ayuda/formulario-recargas/paso-1',
      pagename: 'Formulario Recargas Paso 1',
    });
  }, []);

  return (
    <Fieldset>
      <Field>
        <AffectedNumberField
          helperText="Ingresa el número al que se recargó"
          name="number"
          label="Teléfono"
          setError={setError}
        />
      </Field>
      <Field>
        <FieldTitle>Correo de contacto</FieldTitle>
        <TextInput label="Correo" name="mail" />
      </Field>
      <Field>
        <FieldTitle>Monto de la recarga</FieldTitle>
        <TextInput
          label="Monto"
          name="rechargeAmount"
          onChange={e => {
            const { value } = e.target;
            e.target.value = value.replace(/[^0-9]/g, '');
          }}
        />
      </Field>
    </Fieldset>
  );
};

StepOne.propTypes = {
  setError: PropTypes.func.isRequired,
};

export default StepOne;
